<p-tabView>
    <p-tabPanel header="Roles">
        <p-treeTable #roleTreeTable [value]="hierarchyRoles">
            <ng-template pTemplate="caption">
                <div class="p-text-right">
                    <button pButton type="button" label="Expand All" (click)="expandAllRoles()" class="p-mr-2"></button>
                    <button pButton type="button" label="Collapse All" (click)="collapseAllRoles()"></button>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 350px;">Name</th>
                    <th>Created By</th>
                    <th>Last Updated</th>
                    <th>Associated User</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr [ttRow]="rowNode">
                    <td class="action" style="width: 350px;">
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{rowData.roleName}}
                    </td>
                    <td>{{rowData.createdBy}}</td>
                    <td>{{rowData.lastUpdateDate | localDate}}</td>
                    <td class="p-col-2 click-enable" (click)="getNoOfAssociatedUsers(rowData.id, rowData.roleName)" > {{rowData?.noOfAssociatedUsers}} </td> 
                    <td *ngIf="rowData?.roleName == companyName"></td>
                    <td class="action" *ngIf="rowData?.roleName !== companyName">
                        <span class="btnBars p-mr-0" pTooltip="Add" tooltipPosition="top" (click)="addNewRole(rowData)">
                            <i class="pi pi-plus"></i>
                        </span>
                        <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="editRole(rowData, rowNode)">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top" (click)="deleteRoleHierarchy(rowData)">
                            <i class="pi pi-trash"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>
        </p-treeTable>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
          <p-menu #configmenuUser id="config_menu_user" [model]="configMenuRoleItems" [popup]="true"
            appendTo="body"></p-menu>
          <span class="btnBars p-mr-0" (click)="configmenuUser.toggle($event)">
            <i class="pi pi-bars"></i>
          </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>


<p-dialog header="{{roleHeader}}" [(visible)]="displayAddEditRole" [modal]="true" [responsive]="true"
    [style]="{width: '60em'}" (onHide)="cancelRoleHierarchy()">
    <form [formGroup]="roleHierarchyForm" (ngSubmit)="saveRoleHierarchy()" #createRoleHierarchy="ngForm">
        <div class="card">
            <div class="p-grid">
              <div class="p-col-12 p-md-6">
                <label>Name <span style="color: red;">*</span></label>
                <input 
                    type="text" 
                    pInputText 
                    formControlName="roleName"> 
                <small *ngIf="roleName.invalid && (roleName.touched || roleName.dirty)" class="p-invalid">
                    <span *ngIf="roleName.errors?.['required']" class="p-invalid">
                      Role name is required
                    </span>
                  </small>
              </div>
              <div class="p-col-12 p-md-6" *ngIf="!disableNode">
                <label>Reported To <span style="color: red;">*</span></label>
                <p-treeSelect 
                    [options]="reportedToList"
                    [(ngModel)]="selectedNode" 
                    placeholder="Select Item"
                    appendTo="body" 
                    formControlName="parentId"></p-treeSelect>
                <small *ngIf="parentId.invalid && (parentId.touched || parentId.dirty)" class="p-invalid">
                    <span *ngIf="parentId.errors?.['required']" class="p-invalid">
                      Reported to is required
                    </span>
                </small>
              </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="cancelRoleHierarchy()" label="{{'Configuration.User.Cancel' | transloco}}"
        class="p-button-secondary"></button>
        <button type="button" pButton label="{{'Configuration.User.Save' | transloco}}" [disabled]="roleHierarchyForm.invalid"
        (click)="createRoleHierarchy.ngSubmit.emit()"></button>
    </p-footer>
</p-dialog>

<app-shared-associated-users 
    [displayAssociatedUsersModal]="displayAssociatedUsersModal"
    [associatedUsersFrom]="subModuleName"
    [associatedUsersSubModuleId]="roleHierarchyIdForSelectedAssociatedUser"
    [associatedUsers]="associatedUsers"
    [selectedRoleHierarchyName]="selectedRoleHierarchyName"
    (closeAssociatedUserModalOutputEvent)="closeAssociatedUserModalOutputEvent()"
    (completedAddNewUser)="completedAddNewUser()">
    
</app-shared-associated-users>

<!-- Transfer Role  Modal -->
<p-dialog header="Transfer Role" [modal]="true" [(visible)]="displayTransferRoleModal" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="closeTransferRoleModal()">
    <form [formGroup]="roleTransferForm">
        <div class="card">
          <div class="p-grid">
            <div class="p-col-12" >
                <p >Role to be deleted: <b>{{roleForTransfer?.roleName}}</b></p>
            </div>
            <div class="p-col-12" >
              <label for="type">Move users to new Role<span style="color: red;">*</span></label>
              <p-treeSelect 
                    [options]="reportedToList"
                    placeholder="Select new role"
                    appendTo="body" 
                    formControlName="role"></p-treeSelect>
                <small *ngIf="role.invalid && (role.touched || role.dirty)" class="p-invalid">
                    <span *ngIf="role.errors?.['required']" class="p-invalid">
                      New role is required
                    </span>
                </small>
          </div>
          </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeTransferRoleModal()" label="Cancel"
            class="p-button-secondary"></button>
        <button pButton (click)="transferAndDeleteRole()" label="Transfer and Delete" [disabled]="roleTransferForm.invalid"></button>
    </ng-template>
</p-dialog>